import React from 'react';
import styled from 'styled-components';


const StudentAndStaffResults = () => {
    const studentFeatures = [
        {
            number: "001",
            title: "Faster Answers",
            description: "No more waiting for office hours",
            icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 54px; height: 54px; flex-shrink: 0; fill="currentColor"; opacity: 0.1; position: absolute; left: 0; top: 0"> <circle opacity="0.1" cx="27" cy="27" r="27" fill="currentColor"></circle> </svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; flex-shrink: 0; position: absolute; left: 16px; top: 15px"> <g clip-path="url(#clip0_395_1433)"> <path d="M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H15V10H22V4Z" fill="currentColor"></path> <path d="M22.5 16H20.3L22 12H17V18H19V23L22.5 16Z" fill="currentColor"></path> </g> <defs> <clipPath id="clip0_395_1433"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </svg>`
        },
        {
            number: "002",
            title: "Higher Confidence",
            description: "Better clarity across admissions and financial aid",
            icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 54px; height: 54px; flex-shrink: 0; fill="currentColor"; opacity: 0.1; position: absolute; left: 0; top: 0"> <circle opacity="0.1" cx="27" cy="27" r="27" fill="currentColor"></circle> </svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; flex-shrink: 0; aspect-ratio: 1/1; position: absolute; left: 16px; top: 15px"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0001 5.23884C13.9481 5.23884 15.5281 6.81636 15.5281 8.76274C15.5281 10.7091 13.9493 12.2866 12.0001 12.2866C10.052 12.2866 8.47313 10.7091 8.47313 8.76274C8.47313 6.81752 10.052 5.23884 12.0001 5.23884ZM11.3572 18.5648C11.3163 18.6931 11.2004 18.7907 11.0573 18.8009L8.77988 18.9688L10.5064 20.4283C10.5905 20.4896 10.645 20.5895 10.645 20.7007C10.645 20.7393 10.6382 20.7756 10.6268 20.8096L10.0895 22.9989L12.0274 21.8004C12.1341 21.7323 12.2738 21.7255 12.3886 21.797L14.3321 23L13.7959 20.8108C13.7845 20.7767 13.7777 20.7404 13.7777 20.7018C13.7777 20.5895 13.8323 20.4907 13.9163 20.4294L15.6428 18.97L13.3665 18.8009C13.2416 18.7918 13.128 18.7146 13.078 18.5909L12.2125 16.4766L11.3572 18.5648ZM8.70943 18.2958L10.8017 18.1415L11.5946 16.2031H11.5934C11.6457 16.076 11.732 15.9727 11.8399 15.9C11.949 15.8274 12.0762 15.7866 12.2125 15.7866C12.3488 15.7866 12.476 15.8274 12.585 15.9C12.6929 15.9727 12.7781 16.076 12.8304 16.2031L13.6232 18.1415L15.7155 18.2958C15.8518 18.3061 15.9768 18.3549 16.079 18.4354H16.0801C16.1823 18.5149 16.2596 18.625 16.3027 18.7555C16.3448 18.886 16.3459 19.0199 16.3118 19.1436V19.1447C16.2766 19.2696 16.2051 19.3831 16.0994 19.4716L15.0453 20.3625H17.8918C18.127 20.3625 18.3417 20.2694 18.4961 20.1174C18.6529 19.9653 18.7528 19.7542 18.7596 19.5204L18.8278 16.9918C18.8573 15.9046 18.4961 14.8968 17.8805 14.0807C17.2705 13.2738 16.4141 12.6564 15.4384 12.3363C14.9863 12.7086 14.4729 13.0093 13.9151 13.2193C13.3177 13.4451 12.6725 13.5688 12.0001 13.5688C11.3276 13.5688 10.6825 13.4451 10.085 13.2193C9.5284 13.0093 9.01499 12.7086 8.56291 12.3363C7.58832 12.6564 6.73074 13.2738 6.12079 14.0818C5.50514 14.8978 5.14393 15.9056 5.17347 16.9918L5.24162 19.5204C5.24844 19.7542 5.3484 19.9641 5.50515 20.1162C5.66076 20.2683 5.87543 20.3613 6.10942 20.3613H9.37842L8.32433 19.4704C8.21983 19.3819 8.14713 19.2684 8.11078 19.1436L8.10624 19.1232C8.07671 19.0051 8.08011 18.878 8.11987 18.7543C8.1619 18.6238 8.24027 18.5137 8.3425 18.4343C8.447 18.3548 8.57199 18.306 8.70943 18.2958ZM11.6603 1.33934C11.6603 1.15209 11.8125 1 11.9999 1C12.1874 1 12.3396 1.15208 12.3396 1.33934V3.60235C12.3396 3.78961 12.1874 3.9417 11.9999 3.9417C11.8125 3.9417 11.6603 3.78962 11.6603 3.60235V1.33934ZM19.6604 7.43593C19.8478 7.43593 20 7.58801 20 7.77527C20 7.96254 19.8478 8.11462 19.6604 8.11462H17.3954C17.208 8.11462 17.0558 7.96254 17.0558 7.77527C17.0558 7.58801 17.208 7.43593 17.3954 7.43593H19.6604ZM17.0388 2.89284C17.1705 2.76005 17.3863 2.76005 17.5181 2.89284C17.6499 3.02562 17.6499 3.24011 17.5181 3.37289L15.9165 4.97309C15.7848 5.10588 15.5689 5.10588 15.4372 4.97309C15.3043 4.84031 15.3043 4.62582 15.4372 4.49418L17.0388 2.89284ZM4.33964 8.11462C4.15222 8.11462 4 7.96254 4 7.77527C4 7.58801 4.15221 7.43593 4.33964 7.43593H6.60458C6.792 7.43593 6.94309 7.58801 6.94309 7.77527C6.94309 7.96254 6.79088 8.11462 6.60458 8.11462H4.33964ZM6.48077 3.37309C6.34901 3.24031 6.34901 3.02581 6.48077 2.89304C6.61253 2.76026 6.82834 2.76026 6.9601 2.89304L8.56168 4.49325C8.69344 4.62603 8.69344 4.84052 8.56168 4.97217C8.42992 5.10495 8.2141 5.10495 8.08235 4.97217L6.48077 3.37309Z" fill="currentColor"></path> </svg>`
        },
        {
            number: "003",
            title: "Smarter Decisions",
            description: "Students act quickly with accurate, real-time information at their fingertips",
            icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 54px; height: 54px; flex-shrink: 0; fill="currentColor"; opacity: 0.1; position: absolute; left: 0; top: 0"> <circle opacity="0.1" cx="27" cy="27" r="27" fill="currentColor"></circle> </svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; flex-shrink: 0; position: absolute; left: 16px; top: 15px"> <g clip-path="url(#clip0_395_1452)"> <path d="M21 8C19.55 8 18.74 9.44 19.07 10.51L15.52 14.07C15.22 13.98 14.78 13.98 14.48 14.07L11.93 11.52C12.27 10.45 11.46 9 10 9C8.55 9 7.73 10.44 8.07 11.52L3.51 16.07C2.44 15.74 1 16.55 1 18C1 19.1 1.9 20 3 20C4.45 20 5.26 18.56 4.93 17.49L9.48 12.93C9.78 13.02 10.22 13.02 10.52 12.93L13.07 15.48C12.73 16.55 13.54 18 15 18C16.45 18 17.27 16.56 16.93 15.48L20.49 11.93C21.56 12.26 23 11.45 23 10C23 8.9 22.1 8 21 8Z" fill="currentColor"></path> <path d="M15 9L15.94 6.93L18 6L15.94 5.07L15 3L14.08 5.07L12 6L14.08 6.93L15 9Z" fill="currentColor"></path> <path d="M3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z" fill="currentColor"></path> </g> <defs> <clipPath id="clip0_395_1452"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </svg>`
        }
    ];

    const staffFeatures = [
        {
            number: "001",
            title: "Reduced Workload",
            description: "Routine queries handled by AI",
            icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 54px; height: 54px; flex-shrink: 0; fill="currentColor"; opacity: 0.1; position: absolute; left: 0; top: 0"> <circle opacity="0.1" cx="27" cy="27" r="27" fill="currentColor"></circle> </svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; flex-shrink: 0; position: absolute; left: 16px; top: 15px"> <g clip-path="url(#clip0_395_1465)"> <path d="M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z" fill="currentColor"></path> <path d="M21 16V14C18.76 14 16.84 13.04 15.4 11.32L14.06 9.72C13.68 9.26 13.12 9 12.53 9H11.48C10.89 9 10.33 9.26 9.95 9.72L8.61 11.32C7.16 13.04 5.24 14 3 14V16C5.77 16 8.19 14.83 10 12.75V15L6.12 16.55C5.45 16.82 5 17.48 5 18.21C5 19.2 5.8 20 6.79 20H9V19.5C9 18.12 10.12 17 11.5 17H14.5C14.78 17 15 17.22 15 17.5C15 17.78 14.78 18 14.5 18H11.5C10.67 18 10 18.67 10 19.5V20H17.21C18.2 20 19 19.2 19 18.21C19 17.48 18.55 16.82 17.88 16.55L14 15V12.75C15.81 14.83 18.23 16 21 16Z" fill="currentColor"></path> </g> <defs> <clipPath id="clip0_395_1465"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </svg>`
        },
        {
            number: "002",
            title: "Smarter Insights",
            description: "Chat logs and trends inform decision-making",
            icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 54px; height: 54px; flex-shrink: 0; fill="currentColor"; opacity: 0.1; position: absolute; left: 0; top: 0"> <circle opacity="0.1" cx="27" cy="27" r="27" fill="currentColor"></circle> </svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; flex-shrink: 0; position: absolute; left: 16px; top: 15px"> <g clip-path="url(#clip0_395_1475)"> <path d="M7.5 21H2V9H7.5V21ZM14.75 3H9.25V21H14.75V3ZM22 11H16.5V21H22V11Z" fill="currentColor"></path> </g> <defs> <clipPath id="clip0_395_1475"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </svg>`
        },
        {
            number: "003",
            title: "More Time for What Matters",
            description: "Focus on advising and student success strategies",
            icon: `<svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 54px; height: 54px; flex-shrink: 0; fill="currentColor"; opacity: 0.1; position: absolute; left: 0; top: 0"> <circle opacity="0.1" cx="27" cy="27" r="27" fill="currentColor"></circle> </svg><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 24px; height: 24px; flex-shrink: 0; position: absolute; left: 16px; top: 15px"> <g clip-path="url(#clip0_395_1484)"> <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM16.2 16.2L11 13V7H12.5V12.2L17 14.9L16.2 16.2Z" fill="currentColor"></path> </g> <defs> <clipPath id="clip0_395_1484"> <rect width="24" height="24" fill="white"></rect> </clipPath> </defs> </svg>`
        }
    ];

    return (
        <MainContainer>
            <ContentWrapper>
                <MainHeader>
                    <MainTitle>
                        The Impact: <br />
                        &nbsp;Meaningful Results for Students and Staff
                    </MainTitle>
                </MainHeader>
                <SectionsContainer>
                    <FeatureSection>
                        <SectionContainer>
                            <HeaderContainer>
                                <Title>For Students</Title>
                            </HeaderContainer>

                        </SectionContainer>
                        <CardsGrid>
                            {studentFeatures.map((feature, index) => (
                                <FeatureCard
                                    key={index}
                                    number={feature.number}
                                    icon={feature.icon}
                                    title={feature.title}
                                    description={feature.description}
                                />
                            ))}
                        </CardsGrid>
                    </FeatureSection>
                    <FeatureSection>
                        <SectionContainer>
                            <HeaderContainer>
                                <Title>For Staff</Title>
                            </HeaderContainer>

                        </SectionContainer>
                        <CardsGrid>
                            {staffFeatures.map((feature, index) => (
                                <FeatureCard
                                    key={index}
                                    number={feature.number}
                                    icon={feature.icon}
                                    title={feature.title}
                                    description={feature.description}
                                />
                            ))}
                        </CardsGrid>
                    </FeatureSection>
                </SectionsContainer>
            </ContentWrapper>
        </MainContainer>
    );
};

const FeatureCard = ({ number, icon, title, description }) => {
    return (
        <Card>
            <CardHeader>
              <Number>{number}</Number>
                <IconContainer dangerouslySetInnerHTML={{ __html: icon }} />
            </CardHeader>
            <CardContent>
                <CardTitle>{title}</CardTitle>
                <CardDescription>{description}</CardDescription>
            </CardContent>
        </Card>
    );
};

const Card = styled.article`
  display: flex;
  width: 360px;
  height: 216px;
  padding: 12px 12px 24px 24px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  border-radius: 32px;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
  position: relative;
  background-color: #fff;
  cursor:pointer;
  transition: all 0.3s ease;
 &:hover {
    background-color: rgba(106, 55, 227, 0.85);
    transform: translateY(-4px);
    box-shadow: 0 8px 25px 0 rgba(106, 55, 227, 0.3);
  }
  // @media (max-width: 991px) {
  //   width: 280px;
  //   margin: 0 auto;
  // }

  @media (max-width: 640px) {
    padding: 16px 16px 20px 20px;
    height: auto;
    width: 82%;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  position: relative;

  @media (max-width: 640px) {
    display: none;
  }
`;
const Number = styled.p`
    font: 16px / 160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
    color: #64636A;
  
  ${Card}:hover & {
    color: #fff; /* hover turns icon white */
  }
`


const IconContainer = styled.div`
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  color: #323232; /* default */

  ${Card}:hover & {
    color: #fff; /* hover turns icon white */
  }
`;


const CardContent = styled.div`
  display: flex;
  padding-right: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  width: 95%;
  position: relative;

  @media (max-width: 640px) {
    align-items: center;
    text-align: center;
  }
`;

const CardTitle = styled.h3`
  color: #070127;
  letter-spacing: -0.2px;
  position: relative;
  font: 600 20px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
 ${Card}:hover & {
    color: #fff;
  }
  @media (max-width: 640px) {
    font-size: 18px;
  }
`;

const CardDescription = styled.p`
  color: #64636a;
  letter-spacing: -0.08px;
  position: relative;
  font: 500 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
 ${Card}:hover & {
    color: #fff;
  }
  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const MainContainer = styled.section`
  position: relative;
  background: linear-gradient(
    0deg,
    rgba(189, 30, 35, 0.08) 53%,
    rgba(51, 51, 51, 0.1) 113.62%
  );
`;


const ContentWrapper = styled.div`
  align-items: center;  
  justify-content: center;
  flex-shrink: 0;
`;

const MainHeader = styled.header`
  color: #141221;
  text-align: center;
  letter-spacing: -0.48px;
  font: 700 48px/120% Inter,  sans-serif;
  padding: 42px 0;

  @media (max-width: 640px) {
    font-size: 28px;  padding: 42px 0 0;
  }
`;

const MainTitle = styled.h1`
  color: rgba(20, 18, 33, 1);
  font: 700 48px Inter, sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 36px;
  }

  @media (max-width: 640px) {
    font-size: 28px;
  }
`;

const SectionsContainer = styled.div`
  gap: 32px;
  @media (max-width: 640px) {
    gap: 30px;
  }
`;

const FeatureSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding: 40px 0;
  position: relative;

  @media (max-width: 640px) {
    padding: 20px 0;
  }
`;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  position: relative;
`;

const CardsGrid = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  position: relative;

  @media (max-width: 991px) {
    gap: 24px;
  }

  @media (max-width: 640px) {
    gap: 20px;
  }
`;

const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  position: relative;
`;

const Title = styled.h2`
  color: #1c1b1f;
  text-align: center;
  letter-spacing: -0.32px;
  position: relative;
  font: 700 32px/120% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;

  @media (max-width: 991px) {
    font-size: 28px;
  }

  @media (max-width: 640px) {
    font-size: 24px;
  }
`;


export default StudentAndStaffResults;
